import React, { useRef } from "react";
import classNames from "classnames";

import {
  ARCHIVABLE_ENTITY_TYPES,
  Space,
} from "@highnote/server/src/core/entities";
import { ReactComponent as DownloadSVG } from "App/common/icons-v2/download.svg";
import { LoadingSpinner } from "App/common/icons/LoadingSpinner";
import { useFileDownload } from "App/common/useFileDownload";
import { PermissionTooltip } from "App/components/PermissionTooltip";
import { useUserDownloadRequests } from "App/components/useEntities/useDownloadRequests";
import { Button, BUTTON_SIZE, BUTTON_THEME } from "App/core/Button";
import "./DownloadSpace.scss";

export const DownloadSpaceMenu = ({
  className,
  space,
}: {
  className?: string;
  space: Space;
}) => {
  const menuRef = useRef<HTMLButtonElement>();
  const { isDownloading, downloadSpace, renderDownloadOption } =
    useFileDownload();
  const { getDownloadRequest } = useUserDownloadRequests();
  const downloadRequest = getDownloadRequest(
    space.id,
    ARCHIVABLE_ENTITY_TYPES.SPACE,
  );
  const isDownloadInProgress = isDownloading || Boolean(downloadRequest);

  return (
    <PermissionTooltip
      title="We're processing this download."
      hasPermission={!isDownloadInProgress}
    >
      <div>
        {renderDownloadOption}
        <Button
          ref={menuRef}
          size={BUTTON_SIZE.LARGE}
          theme={BUTTON_THEME.ICON}
          disabled={isDownloadInProgress}
          className={classNames(
            "DownloadSpaceMenu-button",
            {
              active: isDownloadInProgress,
            },
            className,
          )}
          onClick={() => {
            downloadSpace(space.id);
          }}
        >
          {isDownloadInProgress ? <LoadingSpinner /> : <DownloadSVG />}
        </Button>
      </div>
    </PermissionTooltip>
  );
};
